<template>
  <div class="container">
    <div class="row justify-content-center py-3">
      <div class="col-12 col-lg-6">
        <h4 class="mb-0">{{ $t("views.nav.manageTenant") }}</h4>
        <div class="row border-bottom border-2 mt-4">
          <div class="col my-auto">
            Status
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="fs-5 my-2">
              <span v-if="tenant.activated" class="badge text-bg-success fs-6 fw-normal px-2 py-1 me-2">{{ $t("views.tenant.detail.active") }}</span>
              <span v-else class="badge text-bg-warning fs-6 fw-normal px-2 py-1 me-2">{{ $t("views.tenant.detail.trialPeriod") }}</span>
            </div>
            <div class="fs-5 my-2">
              {{ $t("views.tenant.detail.registeredOn") }} {{ formatDate(new Date(tenant.created)) }}
            </div>
            <p class="mt-3">{{ $t("views.tenant.detail.stripe") }}</p>
            <div>
              <a v-if="tenant.activated" :href="stripeCustomerPortal" target="_blank" class="btn btn-primary mb-1">{{ $t("views.tenant.detail.manageSubscription") }}</a>
              <a v-else :href="stripeURL" class="btn btn-primary mb-1">{{ $t("views.tenant.detail.subscribe") }}</a>
            </div>
          </div>
        </div>
        <div v-if="tenant.invoices?.length" class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <div class="fs-5 my-2">
                  {{ $t("views.tenant.detail.invoices") }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <ul class="list-group">
                  <li v-for="invoice in tenant.invoices" :key="invoice.id" class="list-group-item d-flex justify-content-between">
                    <span>{{ formatDate(new Date(invoice.created * 1000)) }}</span>
                    <a :href="invoice.pdf" target="_blank" class="text-primary fw-bold ms-auto">PDF</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row border-bottom border-2 mt-5">
          <div class="col my-auto">
            {{ $t("views.tenant.detail.name") }} <span class="text-danger">*</span>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="fs-5 my-2">
              <input v-model="form.tenant.name.content" id="name"  @focus="this.$store.state.dialogMessage = ''" :class="form.tenant.name.error === '' ? 'form-control' : 'form-control is-invalid'">
              <div class="invalid-feedback form-label small">{{ form.tenant.name.error }}</div>
            </div>
          </div>
          <div class="col-12">
            <div v-if="dialogError" class="modal-footer bg-light justify-content-between">
                <label class="form-label small text-danger" >{{ this.$store.state.dialogMessage }}</label>
            </div>
          </div>
          <div class="fs-5 my-2">
            <button @click="save()" type="button" class="btn btn-sm btn-primary">{{ $t("general.modify") }}</button>
          </div>
        </div>
        <div class="row border-bottom border-2 mt-5">
          <div class="col my-auto">
            {{ $t("views.tenant.detail.deleteTenant") }}
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="mt-3">{{ $t("views.tenant.detail.mailTo") }}
              <a href="mailto:support@focusmt.de">support@focusmt.de</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as validation from '@/composables/validation'
import * as formatUtils from '@/composables/formatUtils'

export default {
  name: 'SettingsManageTenant',
  data () {
    return {
      stripeURL: process.env.VUE_APP_STRIPE_URL,
      stripeCustomerPortal: process.env.VUE_APP_STRIPE_CUSTOMER_PORTAL,

      form: {
        tenant: {
          name: {
            content: '',
            error: '',
            maxLength: 255,
            validate: ['empty', 'length']
          }
        }
      }
    }
  },
  computed: {
    tenant () {
      return this.$store.state.tenant
    },
    dialogError () {
      if (this.$store.state.dialogMessage === '') return false
      else return true
    }
  },
  methods: {
    async activateTenant (checkoutId) {
      this.$store.commit('SET_LOADING_STATUS', true)
      await this.$store.dispatch('updateTenant', { action: 'subscribed', id: checkoutId })
      this.$store.commit('SET_LOADING_STATUS', false)
    },
    async save () {
      this.$store.commit('SET_LOADING_STATUS', true)
      this.$store.state.dialogMessage = ''
      const tenant = this.$store.state.tenant

      let valid = 0
      valid = validation.fieldValidation(this.form.tenant)

      if (valid === 0) {
        Object.keys(this.form.tenant).forEach(field => {
          tenant[field] = this.form.tenant[field].content
        })

        await this.$store.dispatch('updateTenant', { action: 'update', tenantName: tenant.name }).then(() => {
          if (this.$store.state.dialogMessage === '') {
            this.$store.dispatch('getTenant')
            this.form.tenant.name.error = ''
          }
        })
      }
      this.$store.commit('SET_LOADING_STATUS', false)
    },
    formatDate (date) {
      const userLocale = this.$store.state.user.settings?.language
      return formatUtils.formatDate(userLocale, date)
    }
  },
  beforeMount () {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('action') === 'subscribed' && urlParams.get('id')) {
      this.activateTenant(urlParams.get('id'))
    }
  },
  async created () {
    this.$store.commit('SET_LOADING_STATUS', true)
    await this.$store.dispatch('getTenant')
    this.$store.state.dialogMessage = ''
    this.form.tenant.name.content = this.tenant.name
    this.$store.commit('SET_LOADING_STATUS', false)
  }
}
</script>
